// Landing Page Configuration
// Use this number to switch between different landing pages:
// 1 = Home (Find Halal Funding)
// 2 = PartnerWithUs (Launch Islamic Financing)
// Future: 3 = Third landing page (when added)

export const LANDING_PAGE_CONFIG = 1;

// Landing page mappings
export const LANDING_PAGES = {
  1: 'home',
  2: 'partner',
  // Future: 3: 'third-page'
};

